export const addresses = [
  {
    name: "1 impasse Grégoire Collas 95100 ARGENTEUIL",
    href: "https://maps.app.goo.gl/tDibXDE5NVnGB5PT9",
  },
  {
    name: "6 allée Romain Rolland 95100 ARGENTEUIL",
    href: "https://maps.app.goo.gl/fKW5XxW4ntoQmrG57",
  },
];
